import { useContext } from 'react';
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Alert,
  Typography,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  Checkbox,
} from '@mui/material';
import { useModal } from 'components/Modals';
import { useForm, Controller } from 'react-hook-form';
import { AnuncioContext } from 'contexts/AnuncioContext';
import Button from 'components/Button';

const VincModal = ({ callback, filter }) => {
  const defaultValues = { vincular: true, confirm: false };
  const { closeModal } = useModal();
  const { control, handleSubmit, watch } = useForm({ defaultValues });
  const { postLoading, vincAnuncio } = useContext(AnuncioContext);
  const vincular = watch('vincular');

  const onSubmit = ({ confirm, ...rest }) => {
    if (!confirm) return;
    const data = { filter, ...rest };
    vincAnuncio({ data, cb: callback });
  };

  return (
    <>
      <DialogTitle>Vincular Anúncios</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Alert severity="warning">
              Esta ação será aplicada a <b>TODOS os registros filtrados</b>.
            </Alert>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle1" fontWeight="bold">
              O que deseja fazer?
            </Typography>
            <Controller
              name="vincular"
              control={control}
              render={({ field }) => (
                <FormControl>
                  <RadioGroup
                    value={field.value}
                    onChange={(e) => field.onChange(e.target.value === 'true')}
                  >
                    <FormControlLabel
                      value="true"
                      control={<Radio />}
                      label="Vincular Anúncios"
                    />
                    <FormControlLabel
                      value="false"
                      control={<Radio />}
                      label="Desvincular Anúncios"
                    />
                  </RadioGroup>
                </FormControl>
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Controller
              name="confirm"
              control={control}
              render={({ field }) => (
                <FormControlLabel
                  control={<Checkbox {...field} checked={field.value} />}
                  label={
                    vincular
                      ? 'Confirmo que desejo vincular todos os registros filtrados'
                      : 'Confirmo que desejo desvincular todos os registros filtrados'
                  }
                />
              )}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSubmit(onSubmit)} loading={postLoading}>
          Confirmar
        </Button>
        <Button onClick={closeModal} color="secondary">
          Cancelar
        </Button>
      </DialogActions>
    </>
  );
};

export default VincModal;
